var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadioDefaultBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "radio button mini"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 7,
    height: 7,
    stroke: "#005BFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioDefaultBlue);
export default __webpack_public_path__ + "static/media/radioDefaultBlue.657173c8723652c27ad6b879d36f6ace.svg";
export { ForwardRef as ReactComponent };